export default __webpack_public_path__ + "static/media/gmail.74a8750b.svg";